import type { OutreachDraftStatus } from '../types';

export interface ReviewDraftRef {
  id: string;
  status: OutreachDraftStatus;
}

export function isReviewActionable(status: OutreachDraftStatus): boolean {
  return status === 'pending_review' || status === 'edited' || status === 'blocked';
}

export function adjacentDraftId(
  drafts: ReviewDraftRef[],
  currentId: string,
  direction: 'previous' | 'next',
): string | null {
  const index = drafts.findIndex((draft) => draft.id === currentId);
  if (index < 0) return null;
  const adjacent = drafts[index + (direction === 'next' ? 1 : -1)];
  return adjacent?.id ?? null;
}

export function nextActionableDraftId(
  drafts: ReviewDraftRef[],
  currentId: string,
): string | null {
  const index = drafts.findIndex((draft) => draft.id === currentId);
  if (index < 0) return null;
  return drafts.slice(index + 1).find((draft) => isReviewActionable(draft.status))?.id ?? null;
}

export async function navigateAfterSaving(input: {
  dirty: boolean;
  save(): Promise<void>;
  navigate(): void;
}): Promise<void> {
  if (input.dirty) await input.save();
  input.navigate();
}
